const CompanyDisplayNameMap = Object.freeze({
  'location': 'Location',
  'employeeCount': 'Employees',
  'industry': 'Category',
  'subIndustry': 'Sub-Category',
  'moneyRaised': 'Raised',
  'marketCap': 'Revenue Range',
  'tags': 'Tags',
  'description': 'About'
})

export default CompanyDisplayNameMap


// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Company/CompanyDisplayNameMap.js